// @flow

import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import styler from 'react-styling';
import { ListGroupItem, Checkbox } from 'react-bootstrap/lib';
import radium from 'radium';
import { observer } from 'mobx-react';

import { Spinner, ContactItem } from './index';
import breakpoints from '../../css/breakpoints';
import { uiStateStoreInstance } from '../Stores/UIStateStore';

const style = styler `
  Checkbox
    position: absolute
    right: 25px
    bottom: 1px
  Checkbox2
    position: absolute
    right: 28px
    bottom: 14px
    width: 20px
    height: 20px
    border-radius: 4px
    border: 1px solid #CCC
    &Unchecked
      background-color: #FFF
    &Checked
      background-color: #EAEFFA
  Checkmark
    position: absolute
    left: 1px
    top: 1px
    color: #497BEB
  AllCheckBox
    opacity: 0.01
    position: fixed
    z-index: 1000
    left: 415px
    margin-top: -45px
    &Unchecked
      opacity: 1
      left: 412px
      margin-top: -43px
      width: 20px
      height: 20px
      background-color: #FFF
      border: 1px solid #CCC
      border-radius: 4px
      z-index: 998
      &Checked
        background-color: #EAEFFA
        z-index: 999
  SpinnerContainer
    margin: 30px 0 20px
  Spinner
    position: relative
  List
    height: 100%
    padding: 70px 0
    font-size: 16px
    width: 400px
    @media screen and (max-width: ${breakpoints.MEDIUM_AND_ABOVE}px)
      width: 100%
  Item
    padding-left: 10
    padding-right: 0
    border: 0
    border-radius: 0
    box-shadow: 0
    background-color: #F5F5F5
    height: 50px
    color: #666
    outline: none
    transition: all 0.3s
    -webkit-transition: all 0.3s
  Scroll
    margin-top: -10px
    overflow-x: hidden
  `;


@observer
export class List extends Component {
  props: {
    type: string,
    listItems: Array<any>,
    letterNew: Function,
    selectedContact: string,
    toggleItem: Function,
    loadMore: Function,
    hasMore: boolean,
    mode: string,
    selectedContactEmail: string,
    handleAllSelection: Function,
  };

  _handleAllSelection = () => {
    uiStateStoreInstance.isAllSelected = !uiStateStoreInstance.isAllSelected;
    const checked = uiStateStoreInstance.isAllSelected;
    const { listItems } = this.props;
    const { type } = this.props;
    this.props.handleAllSelection(listItems, checked, type);
  }

  _renderCheckbox = () => {
    if (uiStateStoreInstance.isAllSelected) {
      return (
        <div>
          <div style={style.AllCheckBox.Unchecked.Checked}><i className="fa fa-check" style={style.Checkmark} aria-hidden="true" /></div>
          <Checkbox style={style.AllCheckBox} onChange={this._handleAllSelection} checked={uiStateStoreInstance.isAllSelected} />
        </div>);
    }
    return (
      <div>
        <div style={style.AllCheckBox.Unchecked} />
        <Checkbox style={style.AllCheckBox} onChange={this._handleAllSelection} checked={uiStateStoreInstance.isAllSelected} />
      </div>);
  }

  render() {
    const { mode } = this.props;
    let list;
    if (mode === 'single') {
      list = this.props.listItems.map((contact, index) =>
        <div key={index}>
          {this.props.letterNew(this.props.listItems, contact, index)}
          <ListGroupItem
            style={style.Item}
            bsStyle={this.props.selectedContactEmail === contact.email ? 'info' : null}
            onClick={() => { this.props.toggleItem(contact.email, this.props.type); }}
          >
            <ContactItem
              imagePath={contact.email ? `/contacts/photo/${contact.email}` : null}
              displayName={contact.displayName}
            />
          </ListGroupItem>
        </div>
        );
    } else {
      list = this.props.listItems.map((contact, index) =>
        <div key={index}>
          {this.props.letterNew(this.props.listItems, contact, index)}
          <ListGroupItem
            style={style.Item}
            className="scheduler-item"
            bsStyle={this.props.selectedContact.includes(contact.email) ? 'info' : null}
            onClick={() => { this.props.toggleItem(contact.email, this.props.type); }}
          >
            <ContactItem
              imagePath={contact.email ? `/contacts/photo/${contact.email}` : null}
              displayName={contact.displayName}
            />
            {this.props.selectedContact.includes(contact.email) ? (
              <div>
                <Checkbox style={style.Checkbox} onChange={() => { this.props.toggleItem(contact.email, this.props.type, contact.id); }} checked />
                <div style={style.Checkbox2.Checked}>
                  <i className="fa fa-check" style={style.Checkmark} aria-hidden="true" />
                </div>
              </div>
            ) : (
              <div>
                <Checkbox style={style.Checkbox} onChange={() => { this.props.toggleItem(contact.email, this.props.type, contact.id); }} checked="" />
                <div style={style.Checkbox2.Unchecked} />
              </div>
            )}
          </ListGroupItem>
        </div>
    );
    }
    return (
      <div style={style.List}>
        <InfiniteScroll
          next={this.props.loadMore}
          hasMore={this.props.hasMore}
          loader={<div style={style.SpinnerContainer}> <Spinner size="small" style={style.Spinner} /> </div>}
          scrollThreshold={1.0}
          endMessage=" "
          style={style.Scroll}
        >
          { mode === 'multi' ?
             this._renderCheckbox()
            : null}
          { list }
        </InfiniteScroll>
      </div>
    );
  }
}

export default radium(List);



// WEBPACK FOOTER //
// ./src/js/Components/List.js